import React from 'react';
import {Button, Modal, ModalClose, ModalDialog, Stack,} from "@mui/joy";
import Box from "@mui/joy/Box";

// components
import UserContext from "../../context/UserContext";


// icons
import AddIcon from '@mui/icons-material/Add';
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import withNavigate from "../../utils/withNavigate";
import withColorScheme from "../../utils/withColorScheme";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import ListItemContent from "@mui/joy/ListItemContent";
import ListItemButton from "@mui/joy/ListItemButton";


class OpportunityCreate extends React.Component {
    static contextType = UserContext

    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            room: null
        }
        this.formFields = [
            {
                name: 'title',
                label: 'Название',
                xs: 12,
                sm: null,
                md: null,
                lg: null,
                xl: null,
                required: true,
                default: '',
                type: 'input',
            },
            {
                type: 'submit',
                label: 'Создать',
            },
        ]
    }

    async setModalOpenTrue() {
        this.setState(
            {
                modalOpen: true,
            }
        );
    }

    async setModalOpenFalse() {
        this.setState(
            {
                modalOpen: false,
            }
        );
    }

    async processForm(form){
        let formDataObj = Object.fromEntries(form.state.formData.entries());
        const url = 'opportunity/';
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201){
            this.props.navigate(`/opportunity/detail/${response.data.id}/`);
            await this.setModalOpenFalse();
        }
    }

    render() {
        return (
            <>
                <ListItemButton
                    onClick={this.setModalOpenTrue.bind(this)}
                    color={'success'}
                    sx={{
                        ml: 2
                    }}
                >
                    <ListItemDecorator>
                        <AddIcon
                            fontSize="lg"
                        />
                    </ListItemDecorator>
                    <ListItemContent>
                        {this.props.label || 'Добавить'}
                    </ListItemContent>
                </ListItemButton>
                <Modal
                    open={this.state.modalOpen}
                >
                    <ModalDialog
                        layout={'center'}
                        size="lg"
                    >
                        <ModalClose
                            onClick={this.setModalOpenFalse.bind(this)}
                        />
                        <Box
                            // sx={{
                            //     // overflowY: 'scroll',
                            //     maxWidth: 'calc(80vw)',
                            //     width: 'calc(80vw)',
                            //     maxHeight: 'calc(80vh)',
                            //     height: 'calc(80vh)',
                            // }}
                        >
                            <CommonForm
                                fields={this.formFields}
                                processForm={this.processForm.bind(this)}
                            />
                        </Box>
                    </ModalDialog>
                </Modal>
            </>
        )
    }

}

export default withNavigate(withColorScheme(OpportunityCreate))
